// src/components/ui/card.js
export const Card = ({ children, ...props }) => (
  <div className="bg-white rounded-xl shadow p-4" {...props}>
    {children}
  </div>
);
